import {Component, Input} from '@angular/core';
import {AnnotationHandler} from '../../annotation-handler';

@Component({
    selector: 'app-annotation-parents',
    templateUrl: './annotation-parents.component.html',
    styleUrls: ['./annotation-parents.component.scss'],
    standalone: false
})
export class AnnotationParentsComponent {
  @Input() curAnn: AnnotationHandler;
  @Input() isDialog: boolean;
}
